define('admin/index',['durandal/app', 'plugins/router', 'jquery'], function(app, router, $) {
    var childRouter = router.createChildRouter().makeRelative({
        moduleId: 'admin',
        fromParent: true
    }).map([
        { route: ['companies'], moduleId: 'companies/index', title: 'Companies Administration' },
        { route: ['teams'], moduleId: 'teams/index', title: 'Teams and Users Administration' },
        { route: ['teams/teams'], moduleId: 'teams/teams', title: 'Teams and Users Administration' },
        { route: ['teams/users'], moduleId: 'teams/users', title: 'Teams and Users Administration' },
        { route: ['teams/invite'], moduleId: 'teams/invite', title: 'Teams and Users Administration' },
        { route: ['teams/teamUsers'], moduleId: 'teams/teamUsers', title: 'Teams and Users Administration' }
    ]).buildNavigationModel();

    var viewmodel = function() {
        var self = this;
        self.router = childRouter;
        self.app = app;

        self.router.on('router:navigation:processing', function (instruction) {
            app.updateLayoutView(instruction.config.isEditor);
        });
        
        self.canActivate = function() {
            return true;
        };
    };
    return viewmodel;
});

